/** DOM ids used for auto-scroll between flow steps. */
export const PRODUCT_CREATIVE_CONFIG_ANCHOR_ID = "product-creative-config";

/** DB `pipeline` column value for this flow (server + useGeneratedImages + pending-boost key). */
export const PRODUCT_CREATIVE_PIPELINE = "product_creative";
